import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'
import { write, utils } from 'xlsx'
import Select from 'react-select'

class StoreReports extends React.Component {
  state = {
    storeList: [],
    typeTagList: [],
    country_list: [],
    Data: [],
    reportUrl: '',
    isSearching: false,

    // filters
    storeId: null,
    start_date: '',
    country: '',
    end_date: '',
    booking_date: null,
    booking_from: null,
    booking_to: null,
    bookingStatus: '',
    type: '',
  }

  componentDidMount() {
    this.loadData()
    this.setState({
      typeTagList: Constant.getTypeTags(),
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.type !== prevProps.match.params.type) {
      this.setState({
        storeId: null,
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        country: '',
        end_date: moment().format('YYYY-MM-DD'),
        booking_date: null,
        booking_from: null,
        booking_to: null,
        bookingStatus: '',

        Data: [],
      })
    }
  }

  loadData() {
    this.setState(
      {
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      () => {
        this.detailsSummary()
      }
    )
    this.getCountries()
  }

  getStoreList = async () => {
    await axios
      .get(Constant.getAPI() + '/store/stores-list', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: this.state.country,
          type: this.state.type,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            storeList: res?.data?.data?.map((itm) => ({
              label: `${itm.company_name}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDiwaniyaList = async () => {
    await axios
      .get(Constant.getAPI() + '/cruise/list-diwaniya-categories', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: this.state.country,
          type: this.state.type,
          activeOnly: true,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            storeList: res?.data?.data?.map((itm) => ({
              label: `${itm.company_name}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  clearSearch = async () => {
    this.setState({
      bookingStatus: '',
      country: '',
      storeId: null,
      start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      booking_from: '',
      booking_to: '',
      type: '',
      booking_date: '',
      Data: [],
      storeList: [],
    })
  }

  searchData = async () => {
    this.detailsSummary()
  }

  detailsSummary = async () => {
    var dateDMY1 = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY2 = moment(this.state.end_date).format('MM/DD/YYYY')
    let data = {
      bookingStatus: this.state.bookingStatus ? this.state.bookingStatus : null,
      country: this.state.country,
      type: this.state.type,
    }

    if (dateDMY1 && dateDMY1 != 'Invalid date') data.bookingDateFrom = dateDMY1
    if (dateDMY2 && dateDMY2 != 'Invalid date') data.bookingDateTo = dateDMY2
    if (this.state.storeId) data.storeId = this.state.storeId?.value || ''
    if (this.state.booking_date) data.booking_date = this.state.booking_date
    if (this.state.booking_from) data.booking_from = moment(this.state.booking_from).format('MM/DD/YYYY')
    if (this.state.booking_to) data.booking_to = moment(this.state.booking_to).format('MM/DD/YYYY')

    this.setState({
      isSearching: true,
      Data: [],
    })
    await axios
      .post(Constant.getAPI() + `/reports/cruise-store-reports`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details?.[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 6
    if (diffMonths > 6) {
      return true
    } else {
      return false
    }
  }

  handleChange = (event) => {
    event.persist()

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (
          (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
          this.checkDateDifference(this.state.start_date, this.state.end_date)
        ) {
          if (event?.target?.name == 'start_date') {
            this.setState({
              end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD'),
            })
          } else {
            this.setState({
              start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD'),
            })
          }
        }
        if (event?.target?.name == 'country') {
          this.setState({
            storeList: [],
            storeId: null,
          })
          if (event.target.value != '') {
            if (this.state.type === 'ADDON') {
              this.getDiwaniyaList()
            } else {
              this.getStoreList()
            }
          }
        }

        if (event?.target?.name == 'type' && this.state.country) {
          this.setState({
            storeList: [],
            storeId: null,
          })
          if (this.state.type === 'ADDON') {
            this.getDiwaniyaList()
          } else {
            this.getStoreList()
          }
        }
      }
    )
  }

  handleClear = () => {
    this.setState({ storeId: null })
  }

  handleStoreChange = (event) => {
    this.setState({
      storeId: event,
    })
  }

  render() {
    let columns = [
      {
        name: 'COUNTRY',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ORDER_NUMBER',
        label: 'Booking ID',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'STORE_NAME',
        label: 'Store Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'SKU',
        label: 'SKU',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'ITEM_NAME',
        label: 'Item Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'AMOUNT',
        label: 'Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'ITEM_QTY',
        label: 'Item Qty',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'TOTAL_AMOOUNT',
        label: 'Total Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'DELIVERY_CHARGE',
        label: 'Delivery Charge',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CUSTOMER_NAME',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'PHONE',
        label: 'Customer Phone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'BOOKING_DATE',
        label: 'Issue Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'TRIP_DATE',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CRUISE_TYPE',
        label: 'Cruise Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CRUISE_NAME_EN',
        label: 'Cruise Name English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CRUISE_NAME_AR',
        label: 'Cruise Name Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'START_TIME',
        label: 'Start Time',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'END_TIME',
        label: 'End Time',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: '',
        label: 'Trip Date & Time',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return <div style={{ textWrap: 'nowrap' }}>{tableMeta.rowData[9] + ' ' + tableMeta.rowData[13]}</div>
          },
        },
      },
      {
        name: 'BOOKING_HOURS',
        label: 'Booking Duration',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'BOOKING_STATUS',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (columns[idx].label) {
              temp[columns[idx].label] = v
            }
          })
          if (temp?.TRIP_DATE && temp?.START_TIME) {
            temp.TRIP_DATE_TIME = temp.TRIP_DATE + ' ' + temp.START_TIME
          }
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>
                        {this.props.match.params.type == 'customer-booking-report'
                          ? 'Customer Booking Report'
                          : 'Store Report'}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {this.props.match.params.type == 'customer-booking-report'
                          ? 'Customer Booking Report'
                          : 'Store Report'}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Booking Status</label>
                            <div className="col-sm-9">
                              <select
                                name="bookingStatus"
                                className="form-control"
                                value={this.state.bookingStatus}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                <option value={'Pending'}>Pending</option>
                                <option value={'Successful'}>Successful</option>
                                <option value={'Cancelled'}>Cancelled</option>
                                <option value={'Confirmed'}>Confirmed</option>
                                <option value={'Incomplete'}>Incomplete</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Type</label>
                            <div className="col-sm-9">
                              <select
                                name="type"
                                className="form-control"
                                value={this.state.type}
                                onChange={this.handleChange}
                              >
                                <option value={''}>Select Option</option>
                                <option value={'ADDON'}>AddOns</option>
                                <option value={'STORE'}>Store</option>
                                <option value={'FOOD'}>Food</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Store Name</label>
                            <div className="col-sm-9">
                              <Select
                                name="storeId"
                                value={this.state.storeId}
                                onChange={this.handleStoreChange}
                                options={this.state.storeList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder="Select Options"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12"
                          style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                        ></div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                id="date"
                                name="start_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                id="date"
                                name="end_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">Booking start</label>
                            <div className="col-md-9">
                              <input
                                type="date"
                                id="booking_from"
                                className="form-control"
                                value={this.state.booking_from}
                                name="booking_from"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">Booking To</label>
                            <div className="col-md-9">
                              <input
                                type="date"
                                id="booking_to"
                                className="form-control"
                                value={this.state.booking_to}
                                name="booking_to"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            {/* <div
                                                            className="col-6"
                                                            style={{ color: 'red' }}
                                                        >
                                                            1. You can get maximum 6 months rocords at a time
                                                            {!this.state.start_date &&
                                                                !this.state.end_date &&
                                                                !this.state.booking_from &&
                                                                !this.state.booking_to && (
                                                                    <span>
                                                                        <br />
                                                                        2. Either select Booking dates or Created dates
                                                                    </span>
                                                                )}
                                                        </div> */}
                            <div className="text-right col-12">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.searchData}
                                    disabled={
                                      (!this.state.start_date && this.state.end_date) ||
                                      (this.state.start_date && !this.state.end_date) ||
                                      (!this.state.booking_from && this.state.booking_to) ||
                                      (this.state.booking_from && !this.state.booking_to) ||
                                      (!this.state.start_date &&
                                        !this.state.end_date &&
                                        !this.state.booking_from &&
                                        !this.state.booking_to)
                                    }
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Store Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreReports
